import clsx from 'clsx';
import React, { createContext, useContext } from 'react';

const Context = createContext<string | null>(null);

export const useVisualContext = () => {
  return useContext(Context);
};

interface VisualContextProps {
  contextName: string;
  className?: string;
  children: React.ReactNode;
}

export default function VisualContext({ contextName, className, children }: VisualContextProps) {
  return (
    <Context.Provider value={contextName}>
      <div className={clsx(`awsui-context-${contextName}`, className)}>{children}</div>
    </Context.Provider>
  );
}
